import DriverService from "@/services/driver.service.js";
import DriverFormatter from "@/helpers/formatters/driver.formatter.js";
import BadgeFormatter from "@/helpers/formatters/badge.formatter.js";

class DriverRepository {

    async getDrivers() {
        const res = await DriverService.getClientDrivers();
        return DriverFormatter.driversFormat(res.data);
    }

    async getDriver(id) {
        const res = await DriverService.getDriver(id);
        return DriverFormatter.driverFormat(res.data);
    }

    async createDriver(data) {
        return await DriverService.createDriver(data);
    }

    async updateDriver(id, data) {
        return await DriverService.updateDriver(id, data);
    }

    async deleteDriver(id) {
        return await DriverService.deleteDriver(id);
    }

    // Badges

    async getDriverBadges(driverId) {
        const res = await DriverService.getDriverBadges(driverId);
        return BadgeFormatter.badgesFormat(res.data);
    }

    async addDriverBadge(driverId, badgeId) {
        return await DriverService.addDriverBadge(driverId, badgeId);
    }

    async removeDriverBadge(driverId, badgeId) {
        return await DriverService.removeDriverBadge(driverId, badgeId);
    }
}

export default new DriverRepository();